import axios from "axios"
import { login_token } from './constant'
import { NormalException } from "./type"

// 请求拦截
axios.interceptors.request.use(req => {
  // 发送请求时，带上token
  const token = localStorage.getItem(login_token)
  if (token) {
    req.headers.set('Authorization', 'Bearer ' + token)
  }
  return req
})

// 响应拦截
axios.interceptors.response.use(res => {
  // 设置token
  
  if (res.headers['access-token']) {
    localStorage.setItem(login_token, res.headers['access-token'])
  }
  // 请求异常，抛出
  if (!res.data.succeeded) {
    console.error(res.data)
    let err = ''
    if (Object.prototype.toString.call(res.data.errors) === '[object String]') err = res.data.errors
    else err = JSON.stringify(res.data.errors)
    throw new NormalException(err)
  }
  // 返回响应值
  return res.data
})

export default axios
